module.exports = __webpack_public_path__ + "media/site/images/carousel_slides/carousel-slide-oee-ui-desktop.pl-33f246dfaadac891a94f450d34c17bdd.png";